import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../../app/services/aha-api";

const initialState = {
  value: [],
  loading: false,
};

export const updateCareDxDropSite = createAsyncThunk(
  "hospitals/updateCareDxDropSite",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.updateDropSite(data)
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const updateCareDxDropSiteSlice = createSlice({
  name: "updateCareDxDropSite",
  initialState,
  reducers: {
    clearUpdateCareDxDropSiteResponse(state, action) {
      state.value = {}
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateCareDxDropSite.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateCareDxDropSite.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(updateCareDxDropSite.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const updateCareDxDropSiteResponse = (state) => state.updateCareDxDropSite.value;
export const updateCareDxDropSiteLoading = (state) => state.updateCareDxDropSite.loading;
export const {clearUpdateCareDxDropSiteResponse} = updateCareDxDropSiteSlice.actions;

export default updateCareDxDropSiteSlice.reducer;
